/**
 * A function that decorates a Storage instance.
 *
 * @callback StorageDecorator
 * @param {Storage} storage
 * The base storage to decorate.
 *
 * @returns {Storage}
 * The decorated storage instance.
 */

module.exports = {};
